import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faSlidersH, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';
import { CarList } from 'src/app/core/models/car.model';
import { CarService } from 'src/app/core/services/car.service';

@Component({
  selector: 'app-car-filter-popup',
  templateUrl: './car-filter-popup.component.html',
  styleUrls: ['./car-filter-popup.component.scss',],
})
export class CarFilterPopupComponent {

  faSlidersH = faSlidersH;
  faTimes = faTimes;
  showFilterPopup = false;
  selectedFilters: any = {};

  @Output() applyFilterEvent = new EventEmitter<any>();
  totalRecordsFound = AppConstants.ZERO;

  constructor(
    private _carService: CarService,
    private _activateRoute: ActivatedRoute
  ) {
    this._activateRoute.queryParams.subscribe({
      next: (data) => {
        this.selectedFilters = { ...data, };
        this.loadCarListing();
      },
    });
  }

  toggleFilter() {
    this.showFilterPopup = !this.showFilterPopup;
  }

  transformParams(oldParams: any, key: string, value: string) {
    // If key exist in current query params
    const existingParam = oldParams[key];
    if (existingParam) {
      const newParams = existingParam.toString().split(',');
      const i = newParams.indexOf(value);
      // If value already exist
      if (i >= AppConstants.ZERO) {
        // Remove value
        newParams.splice(i, AppConstants.ONE);
        // Remove key if no value
        newParams.length ? oldParams[key] = newParams.toString() : delete oldParams[key];
      } else {
        // Append to values
        oldParams[key] = `${existingParam.toString()},${value}`;
      }
    } else {
      // Key not found add to query params
      oldParams[key] = value;
    }
  }

  onFilterChanged({ params, }: any) {
    Object.keys(params).forEach((k: string) => {
      this.transformParams(this.selectedFilters, k, params[k]);
    });
    this.loadCarListing();
  }

  loadCarListing() {
    this._carService.getListedCars(this.selectedFilters).subscribe({
      next: (data: CarList) => {
        this.totalRecordsFound = data.totalRecords;
      },
    });
  }

  clearAllFilter() {
    // TODO
  }

  applyFilters() {
    this.toggleFilter();
    this.applyFilterEvent.emit({
      params: this.selectedFilters,
      url: 'cars',
    });
  }

}
